import { spire360ApiClient } from "./Spire360ApiClient";
import { CareJourneyRoadmap } from "./CareJourneyTypes";

// Care journey roadmap lives on clinical-forms-experience-api's care-journey
// module. It's computed live from the default journey's steps plus the
// patient's clinical-form submissions. Same base-path/gateway convention as
// ClinicalFormsApiHelper.ts. Returns null when no journey is configured.

const GET_CARE_JOURNEY_TIMEOUT_MS = 10000;

function getBasePath(): string {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  return isGatewayEnabled
    ? `${process.env.REACT_APP_CLINICAL_API_URL_GATEWAY}`
    : `${process.env.REACT_APP_CLINICAL_API_URL}`;
}

export interface CareJourneyApi {
  getRoadmap(patientId: string): Promise<CareJourneyRoadmap | null>;
}

export function createCareJourneyApi(): CareJourneyApi {
  return {
    getRoadmap: async (patientId: string) => {
      const response = await spire360ApiClient.get(
        `${getBasePath()}/clinical-forms/members/${patientId}/journey`,
        { timeout: GET_CARE_JOURNEY_TIMEOUT_MS }
      );
      return response.data || null;
    },
  };
}
